var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column"},[(_vm.hasNavBar())?_c('SideBar'):_vm._e(),_c('div',{staticClass:"content d-flex flex-column flex-grow-1"},[(_vm.hasParameterNav())?_c('parameter-nav',{attrs:{"title":_vm.title,"route":_vm.route}}):_vm._e(),_c('router-view',{key:_vm.$route.fullPath})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }